__turbopack_context__.v({
  "badge": "RewardsTierBanner-module__gHl5xa__badge",
  "banner": "RewardsTierBanner-module__gHl5xa__banner",
  "benefits": "RewardsTierBanner-module__gHl5xa__benefits",
  "body": "RewardsTierBanner-module__gHl5xa__body",
  "cta": "RewardsTierBanner-module__gHl5xa__cta",
  "ctaText": "RewardsTierBanner-module__gHl5xa__ctaText",
  "dot": "RewardsTierBanner-module__gHl5xa__dot",
  "dotIcon": "RewardsTierBanner-module__gHl5xa__dotIcon",
  "identity": "RewardsTierBanner-module__gHl5xa__identity",
  "label": "RewardsTierBanner-module__gHl5xa__label",
  "labelCurrent": "RewardsTierBanner-module__gHl5xa__labelCurrent",
  "laurel": "RewardsTierBanner-module__gHl5xa__laurel",
  "laurelFlipped": "RewardsTierBanner-module__gHl5xa__laurelFlipped",
  "reached": "RewardsTierBanner-module__gHl5xa__reached",
  "step": "RewardsTierBanner-module__gHl5xa__step",
  "tier": "RewardsTierBanner-module__gHl5xa__tier",
  "timeline": "RewardsTierBanner-module__gHl5xa__timeline",
  "upcoming": "RewardsTierBanner-module__gHl5xa__upcoming",
});
